import {
   IPhoneNumber,
   IPhoneNumberGroup,
   getGroupedPhoneNumbers,
} from '@forwardflow/features/phone-numbers'

export interface ICampaignAssignedNumber {
   phoneNumber: string
   region: string
   locality: string
   friendlyName?: string
}

/**
 * Converts a campaign assigned phone number to the IPhoneNumber shape
 * used by the phone-numbers feature components.
 */
export const toCampaignPhoneNumber = (
   assigned: ICampaignAssignedNumber
): IPhoneNumber => ({
   phoneNumber: {
      phoneNumber: assigned.phoneNumber,
      friendlyName: assigned.friendlyName || assigned.phoneNumber,
      lata: '',
      locality: assigned.locality || '',
      rateCenter: '',
      latitude: null,
      longitude: null,
      region: assigned.region || '',
      postalCode: null,
      isoCountry: 'US',
      addressRequirements: '',
      beta: false,
      capabilities: { voice: true, SMS: true, MMS: false },
      status: 'active',
   },
   lastUpdated: '',
   campaignCount: 1,
   campaignIds: [],
   campaigns: [],
   engagedConversations: 0,
   conversationStats: {
      avgResponseRate: 0,
      totalMessages: 0,
      totalIncoming: 0,
      totalOutgoing: 0,
   },
})

/**
 * Converts campaign assigned numbers to grouped IPhoneNumberGroup[] format
 * for use with the PhoneNumbers display component.
 */
export const groupCampaignNumbers = (
   numbers: ICampaignAssignedNumber[]
): IPhoneNumberGroup[] => {
   const adapted = numbers.map(toCampaignPhoneNumber)
   return getGroupedPhoneNumbers(adapted)
}
